/*
 * Created by alex@hackerbay.com on 25.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import checkCareStageHelper from "../checkCareStageHelper";
import {ERROR_STATES, STAGES} from "./Stage";
import {
    isBrowser,
    isMobile
} from "react-device-detect";

const DEBUG = true;

/**
 * get next stage -> calls checkCareStageHelper to determine next stage
 * @param ds360APIResult
 * @param state
 * @param orderStatus
 * @param stageStack contains this.stageStack from MainPage.js
 * @returns {*}
 */
function getNextStage(ds360APIResult, state, orderStatus, stageStack){

    const previousStage = state.stage;

    if( DEBUG ) console.log( "#########################################################################################");
    if( DEBUG ) console.log( "FNX: getNextStage // ds360APIResult, state, orderStatus, stageStack, previousStage //START");
    if( DEBUG ) console.log( { ds360APIResult, state, orderStatus, stageStack, previousStage } );
    if( DEBUG ) console.log( "//END" );

    // if user is in CC stage, let checkCareStageHelper determine which is the next stage
    if(isUserInCCStage(ds360APIResult)){
        return checkCareStageHelper(ds360APIResult, previousStage, orderStatus, state, state.debugStateOverride);
    }

    return ERROR_STATES.SERVER_ERROR;
}


/**
 * check if user is in Check Care stage
 * @param ds360APIResult
 * @returns {boolean}
 */
function isUserInCCStage(ds360APIResult){
    return ds360APIResult.stage === "cc";
}


/**
 * check if user is in DSL stage
 * @param ds360APIResult
 * @returns {boolean}
 */
function isUserInSetupStage(ds360APIResult){
    return ds360APIResult.stage === "setup"
}

/**
 * Unconfirmed or initial users who are shown the welcome page, should be sent here
 * @param previousStage
 */
function initialUserStageFlow(previousStage) {

    console.log( "FNX: initialUserStageFlow - previousStage = " + previousStage );

	// Check the previous stage to show the correct next stage without submitting to the API
    switch (previousStage) {

        case STAGES.WELCOME:
            if (isBrowser) {
			    console.log( "FNX: initialUserStageFlow - nextStage = STAGES.APPOINTMENT_SELECT_CALENDAR (isBrowser)" );
                return STAGES.APPOINTMENT_SELECT_CALENDAR;
            }
			console.log( "FNX: initialUserStageFlow - nextStage = STAGES.APPOINTMENT_SELECT" );
            return STAGES.APPOINTMENT_SELECT;

        case STAGES.APPOINTMENT_SELECT:
			console.log( "FNX: initialUserStageFlow - nextStage = STAGES.APPOINTMENT_SELECT_CALENDAR" );
            return STAGES.APPOINTMENT_SELECT_CALENDAR;

        case STAGES.APPOINTMENT_SELECT_CALENDAR:
			console.log( "FNX: initialUserStageFlow - nextStage = STAGES.PREVIOUS_TENANT" );
            return STAGES.PREVIOUS_TENANT;

        case STAGES.PREVIOUS_TENANT:
			console.log( "FNX: initialUserStageFlow - nextStage = STAGES.CHECK_INFORMATION" );
            return STAGES.CHECK_INFORMATION;

        case STAGES.CHECK_INFORMATION:
			console.log( "FNX: initialUserStageFlow - nextStage = STAGES.CURRENT_STATUS" );
            return STAGES.CURRENT_STATUS;

        case STAGES.CONFIRM_APPOINTMENT:
			console.log( "FNX: initialUserStageFlow - nextStage = STAGES.WAITING_FOR_APPOINTMENT" );
            return STAGES.WAITING_FOR_APPOINTMENT;

        default:
			console.log( "FNX: initialUserStageFlow - nextStage = STAGES.WELCOME (default)" );
            return STAGES.WELCOME;

    }
}


export {isUserInSetupStage, isUserInCCStage, getNextStage, initialUserStageFlow}